import CronLogin from 'components/Crons/CronLogin';
import NavbarProvider from 'contexts/NavbarContext';
import useUsuario from 'hooks/useUsuario';
import React from 'react';
import { ToastProvider } from 'react-toast-notifications';
import Main from './components/Main';

const App = () => {
  const { cliCodigoCore, userIsLoggedIn, sso } = useUsuario();
  return (
    <React.Fragment>
      <NavbarProvider>
        {cliCodigoCore && userIsLoggedIn && sso && <CronLogin />}

        {/* <button className='btn btn-primary btn-lg' onClick={handleOnClick}>
        Prueba
      </button> */}
        <ToastProvider autoDismiss autoDismissTimeout={20000} placement="top-center">
          <Main />
        </ToastProvider>
      </NavbarProvider>
    </React.Fragment>
  );
};


export default App;
